<template>
  <div class="vehicle-type-display" id="tabbedRowsSideView">
    <div class="vehicle-row text-center">
      <div class="container container-xl">
        <ul class="nav nav-pills" role="tablist">
          <li role="suvs-tab-side" class="active" v-if="images.suvs.length > 0">
            <a href="#suvs-tab-side" aria-controls="suvs-tab-side" role="tab" data-toggle="pill">Crossovers & SUVs</a>
          </li>
          <li role="cars-tab-side" v-if="images.sedans.length > 0" :class="[(images.suvs.length === 0) ? 'active' : '']">
            <a href="#cars-tab-side" aria-controls="cars-tab-side" role="tab" data-toggle="pill">Sedans & Hatchbacks</a>
          </li>
          <li role="trucks-tab-side" v-if="images.trucks.length > 0">
            <a href="#trucks-tab-side" aria-controls="trucks-tab-side" role="tab" data-toggle="pill">Trucks</a>
          </li>
        </ul>
      </div>
      <div class="container container-xl">
        <div class="tab-content">
          <div role="tabpanel" class="tab-pane fade active in" id="suvs-tab-side" v-if="images.suvs.length > 0">
            <div class="carousel slide hidden-xs carousel-desktop" id="sliderSuvDesktop" v-if="images.suvs.length >= 4">
              <div class="carousel-inner">
                <div class="item" :class="[index === 0 ? activeClass: '']" v-for="(suv, index) in images.suvs" :key="suv.index">
                  <div class="col-sm-4">
                    <h5>{{suv.modelName}}</h5>
                    <div class="vehicle-img">
                      <img class="center-block img-responsive" :alt="suv.modelName" :src="suv.sideView">
                    </div>
                    <a class="gray-btn" href="#">View Inventory</a>
                  </div>
                </div>
              </div>
              <a class="left carousel-control" href="#sliderSuvDesktop" data-slide="prev">
                <img class="carousel-chevron chevron-left chevron-dark" alt="Previous" src="../../static/images/common-icons/left-arrow-black.png">
              </a>
              <a class="right carousel-control" href="#sliderSuvDesktop" data-slide="next">
                <img class="carousel-chevron chevron-right chevron-dark" alt="Next" src="../../static/images/common-icons/right-arrow-black.png">
              </a>
            </div>
            <div v-else class="desktop-row hidden-xs">
              <div class="row">
                <div class="col-sm-4" v-for="(suv, index) in images.suvs" :key="suv.index" :class="[index === 0 ? 'col-sm-offset-' + offsetVal(images.suvs): '']">
                  <h5>{{suv.modelName}}</h5>
                  <img class="vehicle-img img-responsive center-block" :alt="suv.modelName" :src="suv.sideView">
                  <a class="gray-btn" href="#">View Inventory</a>
                </div>
              </div>
            </div>
            <div class="carousel slide visible-xs" id="sliderSuvMobile">
              <div class="carousel-inner">
                <div class="item" :class="[index === 0 ? activeClass: '']" v-for="(suv, index) in images.suvs" :key="suv.index">
                  <h5>{{suv.modelName}}</h5>
                  <img class="vehicle-img img-responsive center-block" :alt="suv.modelName" :src="suv.sideView">
                  <a class="gray-btn" href="#">View Inventory</a>
                </div>
              </div>
              <a class="left carousel-control" href="#sliderSuvMobile" data-slide="prev">
                <img class="carousel-chevron chevron-left chevron-dark" alt="Previous" src="../../static/images/common-icons/left-arrow-black.png">
              </a>
              <a class="right carousel-control" href="#sliderSuvMobile" data-slide="next">
                <img class="carousel-chevron chevron-right chevron-dark" alt="Next" src="../../static/images/common-icons/right-arrow-black.png">
              </a>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane fade in" id="cars-tab-side" v-if="images.sedans.length > 0">
            <div class="carousel slide hidden-xs carousel-desktop" id="sliderSedanDesktop" v-if="images.sedans.length >= 4">
              <div class="carousel-inner">
                <div class="item" :class="[index === 0 ? activeClass: '']" v-for="(sedan, index) in images.sedans" :key="sedan.index">
                  <div class="col-sm-4">
                    <h5>{{sedan.modelName}}</h5>
                    <div class="vehicle-img">
                      <img class="img-responsive center-block" :alt="sedan.modelName" :src="sedan.sideView">
                    </div>
                    <a class="gray-btn" href="#">View Inventory</a>
                  </div>
                </div>
              </div>
              <a class="left carousel-control" href="#sliderSedanDesktop" data-slide="prev">
                <img class="carousel-chevron chevron-left chevron-dark" alt="Previous" src="../../static/images/common-icons/left-arrow-black.png">
              </a>
              <a class="right carousel-control" href="#sliderSedanDesktop" data-slide="next">
                <img class="carousel-chevron chevron-right chevron-dark" alt="Next" src="../../static/images/common-icons/right-arrow-black.png">
              </a>
            </div>
            <div v-else class="desktop-row hidden-xs">
              <div class="row">
                <div class="col-sm-4" v-for="(sedan, index) in images.sedans" :key="sedan.index" :class="[index === 0 ? 'col-sm-offset-' + offsetVal(images.sedans): '']">
                  <h5>{{sedan.modelName}}</h5>
                  <img class="vehicle-img img-responsive center-block" :alt="sedan.modelName" :src="sedan.sideView">
                  <a class="gray-btn" href="#">View Inventory</a>
                </div>
              </div>
            </div>
            <div class="carousel slide visible-xs" id="sliderSedanMobile">
              <div class="carousel-inner">
                <div class="item" :class="[index === 0 ? activeClass: '']" v-for="(sedan, index) in images.sedans" :key="sedan.index">
                  <h5>{{sedan.modelName}}</h5>
                  <img class="vehicle-img img-responsive center-block" :alt="sedan.modelName" :src="sedan.sideView">
                  <a class="gray-btn" href="#">View Inventory</a>
                </div>
              </div>
              <a class="left carousel-control" href="#sliderSedanMobile" data-slide="prev">
                <img class="carousel-chevron chevron-left chevron-dark" alt="Previous" src="../../static/images/common-icons/left-arrow-black.png">
              </a>
              <a class="right carousel-control" href="#sliderSedanMobile" data-slide="next">
                <img class="carousel-chevron chevron-right chevron-dark" alt="Next" src="../../static/images/common-icons/right-arrow-black.png">
              </a>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane fade" id="trucks-tab-side" v-if="images.trucks.length > 0">
            <div class="carousel slide hidden-xs carousel-desktop" id="sliderTruckDesktop" v-if="images.trucks.length >= 4">
              <div class="carousel-inner">
                <div class="item" :class="[index === 0 ? activeClass: '']" v-for="(truck, index) in images.trucks" :key="truck.index">
                  <div class="col-sm-4" :class="[images.trucks.length === 2 ? 'col-sm-offset-2' : '', images.trucks.length === 1 ? 'col-sm-offset-4' : '']">
                    <h5>{{truck.modelName}}</h5>
                    <div class="vehicle-img">
                      <img class="img-responsive center-block" :alt="truck.modelName" :src="truck.sideView">
                    </div>
                    <a class="gray-btn" href="#">View Inventory</a>
                  </div>
                </div>
              </div>
              <a class="left carousel-control" href="#sliderTruckDesktop" data-slide="prev">
                <img class="carousel-chevron chevron-left chevron-dark" alt="Previous" src="../../static/images/common-icons/left-arrow-black.png">
              </a>
              <a class="right carousel-control" href="#sliderTruckDesktop" data-slide="next">
                <img class="carousel-chevron chevron-right chevron-dark" alt="Next" src="../../static/images/common-icons/right-arrow-black.png">
              </a>
            </div>
            <div v-else class="desktop-row hidden-xs">
              <div class="row">
                <div class="col-sm-4" v-for="(truck, index) in images.trucks" :key="truck.index" :class="[index === 0 ? 'col-sm-offset-' + offsetVal(images.trucks): '']">
                  <h5>{{truck.modelName}}</h5>
                  <img class="vehicle-img img-responsive center-block" :alt="truck.modelName" :src="truck.sideView">
                  <a class="gray-btn" href="#">View Inventory</a>
                </div>
              </div>
            </div>
            <div class="carousel slide visible-xs" id="sliderTruckMobile">
              <div class="carousel-inner">
                <div class="item" :class="[index === 0 ? activeClass: '']" v-for="(truck, index) in images.trucks" :key="truck.index">
                  <h5>{{truck.modelName}}</h5>
                  <img class="vehicle-img img-responsive center-block" :alt="truck.modelName" :src="truck.sideView">
                  <a class="gray-btn" href="#">View Inventory</a>
                </div>
              </div>
              <a class="left carousel-control" href="#sliderTruckMobile" data-slide="prev">
                <img class="carousel-chevron chevron-left chevron-dark" alt="Previous" src="../../static/images/common-icons/left-arrow-black.png">
              </a>
              <a class="right carousel-control" href="#sliderTruckMobile" data-slide="next">
                <img class="carousel-chevron chevron-right chevron-dark" alt="Next" src="../../static/images/common-icons/right-arrow-black.png">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";

export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      activeClass: 'active'
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  },
  methods: {
    offsetVal (group) {
      if (group.length === 1) {
        return '4';
      } else if (group.length === 2) {
        return '2';
      } else {
        return '0';
      }
    }
  },
  mounted() {
    (function () {
      var multiCarousel = {
        init: function () {

          $('#tabbedRowsSideView .carousel-desktop .item').each(function () {
            var next = $(this).next();
            if (!next.length) {
              next = $(this).siblings(':first');
            }
            next.children(':first-child').clone().appendTo($(this));

            for (var i = 0; i < $(this).siblings.length - 1; i++) {
              next = next.next();
              if (!next.length) {
                next = $(this).siblings(':first');
              }

              next.children(':first-child').clone().appendTo($(this));
            }
          });
        }
      }
      $('#sliderSuvDesktop').carousel({
        interval: 5000
      })

      $('#sliderSedanDesktop').carousel({
        interval: 5000
      })

      $('#sliderTruckDesktop').carousel({
        interval: 5000
      })

      $(document).ready(multiCarousel.init);
  })(jQuery);
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .vehicle-type-display {
    font-size: 18px;
    background: #fff;
    text-align: center;
    padding: 30px 15px;
    color: #101010;
  }
  .vehicle-type-display .container-xl {
    padding-left: 0px;
    padding-right: 0px;
  }
  .vehicle-type-display ul li {
    display: inline-block;
    float: none;
  }
  .vehicle-type-display ul {
    margin-bottom: 20px;
  }
  .vehicle-type-display .carousel-desktop .item {
    width: 100%;
  }
  .vehicle-type-display .carousel-desktop .item img,
  .vehicle-type-display .desktop-row img {
    max-height: 150px;
    transform: perspective(1px) translateZ(0);
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-property: transform;
    transition-property: transform;
  }
  .vehicle-type-display .item .vehicle-img {
    width: 100%;
  }
  .vehicle-type-display .tab-content h5 {
    color: #2b2b2b !important;
    text-transform: uppercase;
    text-decoration: none !important;
    font-size: 13px;
    font-weight: bold;
    margin: 15px auto;
    letter-spacing: 1px;
  }
  .vehicle-type-display a {
    text-decoration: none !important;
  }
  .vehicle-type-display .gray-btn {
    margin-top: 15px;
    background: var(--primary-color);
    border-color: var(--primary-color);
    color: #fff;
    padding: 10px 30px;
    margin-top: 30px;
    text-transform: uppercase;
    font-size: 13px;
    border-radius: 3px;
    border-width: 2px;
    border-style: solid;
    display: inline-block;
    text-decoration: none !important;
    -webkit-transition: .3s all ease;
    -o-transition: .3s all ease;
    transition: .3s all ease;
  }
  .vehicle-type-display .gray-btn:hover {
    opacity: .7;
  }
  .vehicle-type-display .item img:hover,
  .vehicle-type-display .desktop-row img:hover {
    transform: scale(1.03);
    text-decoration: none;
  }
  .vehicle-type-display .carousel-control.left,
  .vehicle-type-display .carousel-control.right {
    background-image: none;
    width: 30px;
    cursor: pointer;
    -moz-transition: all 300ms ease-out;
    -webkit-transition: all 300ms ease-out;
    -o-transition: all 300ms ease-out;
    transition: all 300ms ease-out;
  }
  .vehicle-type-display .carousel-control img {
    position: absolute;
    top: 50%;
    z-index: 105;
    display: inline-block;
    height: 20px;
    cursor: pointer;
  }
  .vehicle-type-display .carousel-control.left img {
    left: -15px;
  }
  .vehicle-type-display .carousel-control.right img {
    right: -15px;
  }
  .vehicle-type-display .carousel-desktop .carousel-inner {
    position: relative;
    overflow: hidden;
    width: 100%;
  }
  .vehicle-type-display .carousel-desktop .carousel-inner>.item {
    display: none;
    position: relative;
  }

  @media all and (transform-3d),
  (-webkit-transform-3d) {

    .vehicle-type-display .carousel-desktop .carousel-inner>.item.next,
    .vehicle-type-display .carousel-desktop .carousel-inner>.item.active.right {
      left: 0;
      transform: translate3d(33.33333333333333%, 0, 0);
    }

    .vehicle-type-display .carousel-desktop .carousel-inner>.item.prev,
    .vehicle-type-display .carousel-desktop .carousel-inner>.item.active.left {
      left: 0;
      transform: translate3d(-33.33333333333333%, 0, 0);
    }

    .vehicle-type-display .carousel-desktop .carousel-inner>.item.next.left,
    .vehicle-type-display .carousel-desktop .carousel-inner>.item.prev.right,
    .vehicle-type-display .carousel-desktop .carousel-inner>.item.active {
      left: 0;
      transform: translate3d(0, 0, 0);
    }
  }

  .vehicle-type-display .carousel-desktop .carousel-inner .active,
  .vehicle-type-display .carousel-desktop .carousel-inner .next,
  .vehicle-type-display .carousel-desktop .carousel-inner .prev {
    display: block;
  }
  .vehicle-type-display .carousel-desktop .carousel-inner .active {
    left: 0;
  }
  .vehicle-type-display .carousel-desktop .carousel-inner .next,
  .vehicle-type-display .carousel-desktop .carousel-inner .prev {
    position: absolute;
    top: 0;
    width: 100%;
  }
  .vehicle-type-display .carousel-desktop .carousel-inner .next {
    left: 33.33333333333333%;
  }
  .vehicle-type-display .carousel-desktop .carousel-inner .prev {
    left: -33.33333333333333%;
  }
  .vehicle-type-display .carousel-desktop .carousel-inner .next.left,
  .vehicle-type-display .carousel-desktop .carousel-inner .prev.right {
    left: 0;
  }
  .vehicle-type-display .carousel-desktop .carousel-inner .active.left {
    left: -33.33333333333333%;
  }
  .vehicle-type-display .carousel-desktop .carousel-inner .active.right {
    left: 33.33333333333333%;
  }
  .vehicle-type-display .carousel-desktop .next .col-sm-4 {
    opacity: 0;
  }
  .vehicle-type-display .carousel-desktop .next .col-sm-4:last-of-type {
    opacity: 1 !important;
  }
  .vehicle-type-display .nav>li>a {
    color: #999;
    background: #fff;
    text-transform: uppercase;
    border-radius: 0;
    font-weight: bold;
    font-size: 18px !important;
    -moz-transition: all 300ms ease-out;
    -webkit-transition: all 300ms ease-out;
    -o-transition: all 300ms ease-out;
    transition: all 300ms ease-out;
    border-bottom: none;
    cursor: pointer;
  }
  .vehicle-type-display .nav>li>a:hover {
    background: #fff;
    color: #101010;
    border-bottom: none;
  }
  .vehicle-type-display .nav>li.active>a {
    color: #101010;
    background: #fff;
    border-bottom: none;
    border-top: none;
  }

  @media (min-width: 1400px) {
    .vehicle-type-display .container-xl {
      width: 1340px;
      max-width: 1340px;
    }
  }

  @media (max-width: 767px) {
    .vehicle-type-display ul li {
      display: block;
    }
    .vehicle-type-display .carousel-control.left img {
      left: 0px;
    }
    .vehicle-type-display .carousel-control.right img {
      right: 0px;
    }
  }
</style>